export default function loadGoogleAnalyticsScript() {
  // Code copied from Google
  (function(f,b,e,v,r,n,t,s){f.GoogleTagObject=r,f[r]=f[r]||function(){(f[r].q=f[r].q||[]).push(arguments);},f[r].l=1*new Date(),f.dataLayer=f.dataLayer||[],f.gtag=function(){f.dataLayer.push(arguments);},t=b.createElement(e),t.async=!0,t.src=v,s=b.getElementsByTagName(e)[0],s.parentNode.insertBefore(t,s);}(window,document,'script','https://www.googletagmanager.com/gtag/js','async'));
}
